/**
 * FallbackImage React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


import React from 'react';
import {patchServerUrl} from "../../config";
import _ from 'lodash';


const ERROR_IMAGE_URL = "/placeholders/warning.svg";


function makeUrlList(urls) {
    // start with all given non-empty URLs plus an error image as fallback
    if (!urls) return [ERROR_IMAGE_URL];
    else return [...urls.filter(url => !!url), ERROR_IMAGE_URL];
}

/**
 * FallbackImage shows an image (if available) or one or more fallbacks
 *
 * @author Jens Gruschel
 */
export class FallbackImage extends React.Component {

    constructor(props) {
        super(props);
        const urls = makeUrlList(this.props.urls);
        this.state = {
            urls: urls
        };
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(this.props.urls, prevProps.urls)) {
            const urls = makeUrlList(this.props.urls);
            this.setState({
                urls: urls
            });
        }
    }

    onImgError = () => {
        if (this.state.urls.length > 1) {
            // try next image in list
            this.setState({
                urls: this.state.urls.slice(1)
            });
        }
    }

    render() {
        return <img
            className={this.props.className}
            src={patchServerUrl(this.state.urls[0])}
            alt={this.props.title}
            onError={this.onImgError}
            onClick={this.props.onClick}
        />;
    }
}

export default FallbackImage;